var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchDarkEmptyImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 111,
    viewBox: "0 0 81 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9773 0L80.9297 20.5971V110.476H0.929688V0H59.9773Z",
    fill: "#E9EAEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9297 20.9524H59.9773V0L80.9297 20.9524Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3523 20.9521H33.3047V24.7617H12.3523V20.9521Z",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.365 34.286H69.5078V38.0955H12.365V34.286Z",
    fill: "#8E9AAF",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9795 46.9524H54.7891V51.0952H11.9795V46.9524Z",
    fill: "#667085"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.365 60.9528H69.5078V64.7623H12.365V60.9528Z",
    fill: "#8E9AAF",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9795 74.5714H54.7891V78.7143H11.9795V74.5714Z",
    fill: "#667085"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.365 87.6194H69.5078V91.4289H12.365V87.6194Z",
    fill: "#8E9AAF",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDarkEmptyImg);
export default __webpack_public_path__ + "static/media/searchDarkEmptyImg.662bf8e7297bf8183b756e65928cedb6.svg";
export { ForwardRef as ReactComponent };